// A cortina de abertura (`#tela-boot`, no index.html) sai quando a primeira
// tela de verdade está pronta — a mesma regra do painel antigo: some com um
// fade de .32s e é removida depois dele. Idempotente: toda tela que termina
// de carregar pede, e só a primeira conta.
//
// A rede de segurança de 10s também é a do antigo: se alguma coisa travar
// (um chunk que não baixa, um login que não responde), a cortina não pode
// esconder o erro para sempre.
let liberada = false;

export function liberarBoot() {
  if (liberada) return;
  liberada = true;
  const cortina = document.getElementById('tela-boot');
  if (!cortina) return;
  cortina.dataset.saindo = 'sim';
  setTimeout(() => cortina.remove(), 350);
}

export const PRAZO_DA_CORTINA_MS = 10_000;

export function armarRedeDaCortina() {
  setTimeout(liberarBoot, PRAZO_DA_CORTINA_MS);
}

/**
 * A cortina de volta, a mesma do index.html (o CSS dela mora lá), para cobrir
 * o reload que conserta um chunk de versão anterior: quem trocou de tela vê o
 * "carregando seu painel" em vez da tela parada — e, depois do reload, a
 * cortina do index.html assume no mesmo lugar, sem emenda.
 */
export function voltarCortina() {
  const existente = document.getElementById('tela-boot');
  if (existente) { delete existente.dataset.saindo; return; }
  const cortina = document.createElement('div');
  cortina.id = 'tela-boot';
  cortina.setAttribute('role', 'status');
  cortina.setAttribute('aria-live', 'polite');
  cortina.setAttribute('aria-label', 'Carregando seu painel');
  const b = document.createElement('div');
  b.className = 'boot-b';
  b.textContent = 'b';
  const recado = document.createElement('div');
  recado.className = 'boot-recado';
  recado.textContent = 'carregando seu painel';
  cortina.append(b, recado);
  document.body.append(cortina);
}

/** Só para os testes: volta ao estado de antes da primeira liberação. */
export function _reiniciarParaTestes() { liberada = false; }
